import { render, staticRenderFns } from "./History.vue?vue&type=template&id=6d8e6188&scoped=true"
import script from "./History.vue?vue&type=script&lang=js"
export * from "./History.vue?vue&type=script&lang=js"
import style0 from "./History.vue?vue&type=style&index=0&id=6d8e6188&prod&lang=scss"
import style1 from "./History.vue?vue&type=style&index=1&id=6d8e6188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8e6188",
  null
  
)

export default component.exports